import { render, staticRenderFns } from "./CallActivity.vue?vue&type=template&id=089cd3f1&"
import script from "./CallActivity.vue?vue&type=script&lang=js&"
export * from "./CallActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports